import * as React from 'react';
import CloudsImg from '../../static/images/clouds.svg';
import MagnifyingLens from '../../static/images/magnifyingLens.svg';
import { Button } from '../Button/Button';
import { Typography } from '../Typography/Typography';
import { BpDesignSystem } from '../../types';
import { styled } from '../../styles';
import { useIntlBds } from '../../translations/BdsIntlProvider';
import { Box } from '../Box/Box';
import { MouseParallaxIcon } from '../Icon/MouseParallaxIcon';

export type EmptyResultsProps = BpDesignSystem.PropsWithChildren<{
  message?: string;
  height?: number;
  width?: number;
  className?: string;
  buttonConfig?: { label: string; callback: () => void };
  backgroundImgUrl?: string;
  foregroundImgUrl?: string;
}>;

export const EmptyResults: React.FC<React.PropsWithChildren<EmptyResultsProps>> = ({
  height,
  width,
  message,
  buttonConfig,
  backgroundImgUrl,
  foregroundImgUrl,
  dataTest = 'empty-results',
  ...rest
}) => {
  const { intl } = useIntlBds();

  return (
    <StyledEmptyContainer component="div" dataTest={dataTest} $height={height || 200} $width={width || 300} {...rest}>
      <MouseParallaxIcon
        height={height || 200}
        width={width || 300}
        backgroundImgUrl={backgroundImgUrl ?? CloudsImg}
        foregroundImgUrl={foregroundImgUrl ?? MagnifyingLens}
      />
      <StyledMessage>{message ?? intl.EmptyResults.message}</StyledMessage>
      {buttonConfig && (
        <StyledActionButton
          dataTest="empty__result__action__button"
          children={buttonConfig.label}
          variant="contained"
          color="primary"
          onClick={buttonConfig.callback}
          key="confirm"
          size="medium"
        />
      )}
    </StyledEmptyContainer>
  );
};

const StyledActionButton = styled(Button)`
  margin-top: 1.5rem;
  min-height: 2.4rem !important;
  pointer-events: ${(props) => (props?.disabled ? 'none' : 'auto')} !important;
`;

const StyledEmptyContainer = styled(Box)<{ $height: number; $width: number }>`
  flex: 1 1 auto;
  height: ${({ $height }) => $height}px;
  width: ${({ $width }) => $width}px;
  flex-direction: column;
  display: flex;
  align-items: center;
  justify-content: center;
  > span {
    padding-top: 1rem;
  }
`;

const StyledMessage = styled(Typography)`
  && {
    margin-top: 1rem;
  }
`;
